module.exports = __webpack_public_path__ + "img/no.b458d6fd.png";